import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { uploadDataFile } from 'services/document-service';
import FTIcons from 'assets/icons/FTIcons';
import { tokens } from 'theme/tokens';
import ToastHandler from './Toast-Handler/toast-handler';

/**
 * 
 * @param {*} name name of the entity to be uploaded.
 * @returns 
 */

const FileUploader = ({
  name,
  isProcessing,
  message,
  fnOnUploadHandler,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // const [isProcessing, setIsProcessing] = useState(false);
  const [selectedFile, setSelectedFile] = useState({});
  // const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const fileInput = useRef(null);

  const handleFileInput = (e) => {
    var f = e.target.files[0];
    if (f.size < (5e+6) && f.type === 'text/csv') { // 5MB
      setError(null);
      setSelectedFile(e.target.files[0]);
    } else {
      setSelectedFile({});
      setError('Invalid File or File is too big.');
    }
  };

  const handleRateConDocument = (e) => {
    var f = e.target.files[0];
    if (f.size < (5e+6) && f.type === 'application/pdf') { // 5MB
      setError(null);
      setSelectedFile(e.target.files[0]);
    } else {
      setSelectedFile({});
      setError('Invalid Document or Document is too big.');
    }
  };

  const handleRateConUpload = () => {
    const formData = new FormData();
    formData.append('name', name); // driver? broker? etc,
    formData.append('file', selectedFile); // csv file to upload
    fnOnUploadHandler(formData);
  }

  const handleCSVUpload = () => {
    if (selectedFile && selectedFile.type === 'text/csv' && !error) {
      const formData = new FormData();
      formData.append('name', name); // driver? broker? etc,
      formData.append('file', selectedFile); // csv file to upload

      uploadDataFile(formData)
        .then((r) => {
          r = r || {};
          if (r.status === 200 && r.data && r.data.ok === true) {
            setMessage('File has been uploaded, your data will index shortly.');
          } else {
            setError('Failed to upload data. ' + (r.data && r.data.message || ''));
          }
        })
        .catch(() => {
          setError('Failed to upload data');
        })
        .finally(() => {
          setSelectedFile({});
        });
    }
  };

  return (
    name === 'LoadForm' ?
      <Box
        height={'auto'}
        border={`1px solid ${theme.palette.neutral[200]}`}
        borderRadius={'6px'}
        p={2}
        gap={1}
        backgroundColor={colors.base.white}
      >
        <Stack spacing={1} sx={{ alignItems: 'center' }}>
          {isProcessing ? <CircularProgress style={{ margin: 'auto' }} /> : null}
          {message && <ToastHandler toast={message} type={message.type} />}
          <br/>        
          <FTIcons.Folder
            width={40}
            height={30}
            fill={colors.main_blue[200]}
          />
          <Button
            variant='outlined'
            sx={{
              background: colors.main_blue[50],
              border: `1px solid ${colors.primary.light}`,
              color: colors.primary.main
            }}
            startIcon={
              <FTIcons.UploadSimple width={18} height={18} fill={colors.primary.main} />
            }
            onClick={() => fileInput.current && fileInput.current.click()}
          >
            Select Document
          </Button>
          <Typography variant='caption' color={colors.neutral[400]}>Supported format: PDF, Docs, Max file size: 5MB</Typography>
          <input type='file' onChange={handleRateConDocument} ref={fileInput} style={{ display: 'none' }} />
          <br/>
          <Typography variant='body1'>{selectedFile.name}</Typography>
        </Stack>
        <Box
          display='flex'
          justifyContent='flex-end'
          p={2}>
          <Button
            variant='contained'
            color='primary'
            onClick={handleRateConUpload}
            disabled={error || !selectedFile.type}
          >
            Upload Document
          </Button>
        </Box>        
      </Box>
      :
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <input
            type='file'
            ref={fileInput}
            onChange={handleFileInput}
            style={{ display: 'none' }}
          />
          <Button variant='outlined' onClick={() => fileInput.current && fileInput.current.click()} color='primary'>
            Select File
          </Button>
          &nbsp;&nbsp;<span>{selectedFile.name}</span>
        </Grid>
        {isProcessing ? <CircularProgress style={{ margin: 'auto' }} /> : null}
        <Typography variant='subtitle2'>{message}</Typography>
        <Box
          display='flex'
          justifyContent='flex-end'
          p={2}>
          <Button
            variant='contained'
            color='primary'
            onClick={handleCSVUpload}
            disabled={error || !selectedFile.type}
          >
            Upload File
          </Button>
        </Box>
      </Grid>
  );
};

FileUploader.protoTypes = {
  name: PropTypes.string
};

export default FileUploader;